export const testimonials = [
  {
    id: 1,
    name: "Mariana Santos",
    role: "Professora",
    text: "A RCRED me ajudou a realizar o sonho da casa própria. O processo foi rápido e transparente, sem burocracia desnecessária. Indico para todos!",
  },
  {
    id: 2,
    name: "Carlos Oliveira",
    role: "Empresário",
    text: "Fiz um Home Equity para investir no meu negócio. As taxas foram as melhores do mercado e o atendimento foi excepcional. Muito satisfeito!",
  },
  {
    id: 3,
    name: "Fernanda Lima",
    role: "Enfermeira",
    text: "Entrei no consórcio da RCRED e em pouco tempo fui contemplada. Agora tenho meu apartamento com parcelas que cabem no meu orçamento.",
  },
  {
    id: 4,
    name: "Roberto Almeida",
    role: "Corretor de Imóveis",
    text: "Como parceiro da RCRED, consigo oferecer as melhores condições de financiamento para meus clientes. A parceria é muito vantajosa.",
  },
  {
    id: 5,
    name: "Juliana Costa",
    role: "Advogada",
    text: "Refinanciei meu imóvel com a RCRED e consegui reduzir significativamente as parcelas. Equipe muito profissional e atenciosa.",
  },
  {
    id: 6,
    name: "Pedro Henrique",
    role: "Engenheiro",
    text: "O atendimento personalizado fez toda a diferença. Meu consultor me orientou em cada etapa do financiamento. Recomendo demais!",
  },
];